import { getRetrainCostForRole, getTotalRetrainCost } from "./retrainCalculations";
import { getProdLossWithMinBreakIn, getProdLossWithMaxBreakIn } from "./prodLossCalculations";
import { getTotalSystemCost, getItVendorCost, getItPersonnelCost } from "./systemCostCalculations";
import { formatNumber } from "../../Util/util";
import store from "../../Store/configureStore";
import { Typography } from "antd";

const lodash = require("lodash");

const getProdLoss = (breakInMode) => {
  var out = null;

  switch (parseInt(breakInMode)) {
    case 0:
      out = parseFloat(getProdLossWithMinBreakIn());
      break;
    case 1:
      out = (parseFloat(getProdLossWithMinBreakIn()) + parseFloat(getProdLossWithMaxBreakIn())) / 2;
      break;
    case 2:
      out = parseFloat(getProdLossWithMaxBreakIn());
      break;
    default:
      out = parseFloat(getProdLossWithMinBreakIn());
      break;
    //This happens with breakInMode == null, before the user has clicked on the radio button
  }

  return out;
};

export const getOverviewData = (adjustment, breakInMode) => {
  const output = [
    { name: "Retraining Costs", value: parseFloat(getTotalRetrainCost()) },
    { name: "Productivity Loss Costs", value: getProdLoss(breakInMode) },
    { name: "System Change Costs", value: parseFloat(getTotalSystemCost()) },
  ];

  var modifiedOutput = [];
  output.forEach((item) => modifiedOutput.push({ name: item.name, value: adjustment * item.value }));

  return modifiedOutput;
};

export const getDetailedData = (adjustment, breakInMode) => {
  const state = store.getState();
  //remove, add to dependancy array for useMemo()

  const output = [
    { name: "Coder", value: getRetrainCostForRole("coder") },
    { name: "Data Analyst", value: getRetrainCostForRole("analyst") },
    { name: "Manager", value: getRetrainCostForRole("manager") },
    { name: "Data Quality Specialist", value: getRetrainCostForRole("qualitySpecialist") },
    { name: "System Application Coordinator", value: getRetrainCostForRole("applicationCoordinator") },
    { name: "Coding Director", value: getRetrainCostForRole("codingDirector") },
    { name: "Coding Coordinator", value: getRetrainCostForRole("codingCoordinator") },
    { name: "Project Coordinator", value: getRetrainCostForRole("projectCoordinator") },
    { name: "Supervisor", value: getRetrainCostForRole("supervisor") },
    { name: "Data Entry Clerk", value: getRetrainCostForRole("dataEntry") },
    { name: "College Instructor", value: getRetrainCostForRole("collegeInstructor") },
    { name: "Provincial Trainer", value: getRetrainCostForRole("provinceTrainer") },
    { name: "Other", value: parseFloat(lodash.get(state, "costs.retrainCostDetails.othercosts")) },
    { name: "Productivity Loss", value: getProdLoss(breakInMode) },
    { name: "IT Cost", value: getItVendorCost() },
    { name: "IT Personnel Cost", value: getItPersonnelCost() },
    { name: "Other System Costs", value: parseFloat(lodash.get(state, "costs.systemCostDetails.other-system-cost")) },
  ];

  var modifiedOutput = [];
  output.forEach((item) => modifiedOutput.push({ name: item.name, value: adjustment * item.value }));

  return modifiedOutput;
};

export const getSelectedData = (adjustment, breakInMode, index) => {
  //alert("Index is: ".concat(index).concat(" Break in mode is: "))

  switch (index) {
    case 0:
      return getDetailedData(adjustment, breakInMode).slice(0, 13);
    case 1:
      //return (getDetailedData(breakInMode).slice(13,14))
      return [{ name: "Productivity Loss", value: getProdLoss(breakInMode) * adjustment }];
    case 2:
      return getDetailedData(adjustment, breakInMode).slice(14, 17);
    default:
      return [{}];
  }
};

export const getBenefitsData = (adjustment = 1) => {
  const state = store.getState();

  return [
    {
      name: "Computer Assisted Coding",
      value: adjustment * parseFloat(lodash.get(state, "benefits.benefitsDetails.auto-coding")),
    },
    {
      name: "Vendor Cost Savings",
      value: adjustment * parseFloat(lodash.get(state, "benefits.benefitsDetails.vendor-costs-savings")),
    },
    {
      name: "Travel, Accommodation, and Resource Savings",
      value: adjustment * parseFloat(lodash.get(state, "benefits.benefitsDetails.travel-saving")),
    },
    {
      name: "Accurate Billing for Procedures",
      value: adjustment * parseFloat(lodash.get(state, "benefits.benefitsDetails.accurate-billing-saving")),
    },
    {
      name: "Reduction in Miscoded Reimbursement Claims",
      value: adjustment * parseFloat(lodash.get(state, "benefits.benefitsDetails.reduced-claims-savings")),
    },
    {
      name: "Additional Benefits",
      value: adjustment * parseFloat(lodash.get(state, "benefits.benefitsDetails.other-savings")),
    },
  ];
};

export const CustomTooltip = ({ payload }) => {
  const state = store.getState();
  var text = "";
  const currency = lodash.get(state, "currency.currency");
  if (payload[0] && payload[0].payload.payload.name) {
    //for the pie charts
    text = payload[0].payload.payload.name;
    //This is incidebly dumb, and I'm very annoyed at whoever though that there should be tripple nested 'payload' objects.
  } else if (payload[0] && payload[0].payload.payload.target.name) {
    //for the sankey charts
    text = payload[0].payload.payload.target.name;
  }
  if (text) {
    return (
      <div
        className="rechats-default-tooltip"
        style={{
          backgroundColor: "#ffffff",
          border: "1px solid rgb(128, 128, 128)",
          padding: "10px",
          marginTop: "0px",
        }}
      >
        <Typography style={{ fontSize: "12px" }}>
          {text} {" : "}
          {formatNumber(payload[0].value)} {currency}
        </Typography>
      </div>
    );
  } else {
    return null;
  }
};
